import forOwn from "mout/object/forOwn"
import sortByPropText from "../content/manageSets/sortByPropText"
import {
  autoTutorSentences,
  skillWeights,
  tsDataEnglish,
  tsDataMath,
  tsDataReading,
  tsDataScience,
  tsDataSATMath,
  tsDataSATReading,
  tsDataSATWritingAndLanguage,
  tsDataStaarEnglish_i,
  tsDataStaarAlgebra_i,
  tsDataStaarBiology,
  tsDataStaarEnglish_ii,
  tsDataStaarUsHistory,
  autoTutorSentencesStudent
} from "../../../mp-utils/ready-utils/data"

// Generates the auto-tutor recommendations
export default function getAutoTutorRecommendations(
  { testType, byNode, bySubtest, subject, nodes, grabAllSkills },
  isStudent,
  isGroup
) {
  const subjectName = `${testType}_${subject}`
  const selectTsData = {
    ACT_English: tsDataEnglish,
    ACT_Math: tsDataMath,
    ACT_Reading: tsDataReading,
    ACT_Science: tsDataScience,
    "SAT_Math - No Calc": tsDataSATMath,
    "SAT_Math - Calc": tsDataSATMath,
    SAT_Math: tsDataSATMath,
    "SAT_Writing and Language": tsDataSATWritingAndLanguage,
    SAT_Reading: tsDataSATReading,
    "PSAT_Math - No Calc": tsDataSATMath,
    "PSAT_Math - Calc": tsDataSATMath,
    PSAT_Math: tsDataSATMath,
    "PSAT_Writing and Language": tsDataSATWritingAndLanguage,
    PSAT_Reading: tsDataSATReading,
    "STAAR_English I": tsDataStaarEnglish_i,
    "STAAR_Algebra I": tsDataStaarAlgebra_i,
    STAAR_Biology: tsDataStaarBiology,
    "STAAR_English II": tsDataStaarEnglish_ii,
    "STAAR_U.S. History": tsDataStaarUsHistory
  }

  const tsData = selectTsData[subjectName]

  if (!tsData) {
    return Error(
      `subject must be English, Math, Reading, or Science. Submitted ${subject}`
    )
  }

  // checks for tsData existing at scale scores we need
  function getTsDataCheck(nodeName, scale) {
    let checkScales = [0, 1, 2]
    checkScales = checkScales.map(num => {
      return `scale${num + scale}`
    })
    let check = true
    checkScales.forEach(checkScale => {
      if (!tsData[checkScale]) {
        check = false
      } else if (!(nodeName in tsData[checkScale])) {
        check = false
      }
    })
    return check
  }

  // find top three skills
  function getTopThreeSkills(byNode, bySubtest, subject, nodes, isStudent) {
    // for each byNode percent correct, multiply by -3, then add percent corrects from tsData for same scale, +1, and +2, then multiply by skillWeights
    let values = []
    const scale = bySubtest ? Math.round(bySubtest.scale) : 0
    subject = ["Math - No Calc", "Math - Calc"].includes(subject)
      ? "Math"
      : subject
    forOwn(byNode, ({ percentage }, key) => {
      if (key in nodes) {
        const nodeName = nodes[key].name
        const skillWeightsCheck = nodeName in skillWeights[subjectName]
        const tsDataCheck = getTsDataCheck(
          nodeName,
          bySubtest ? Math.round(bySubtest.scale) : 0
        )
        const sentencesCheck =
          autoTutorSentences[subjectName] &&
          nodeName in autoTutorSentences[subjectName]
        const studentSentencesCheck =
          autoTutorSentences[subjectName] &&
          nodeName in autoTutorSentences[subjectName]

        if (
          skillWeightsCheck &&
          tsDataCheck &&
          sentencesCheck &&
          (isGroup || studentSentencesCheck)
        ) {
          const tsTotals =
            tsData[`scale${scale}`][nodeName] +
            tsData[`scale${scale + 1}`][nodeName] +
            tsData[`scale${scale + 2}`][nodeName]
          const value =
            (percentage * -3 + tsTotals) *
            (skillWeights[subjectName][nodeName] * 100)
          values.push({ name: nodeName, value, nodeId: key })
        } else if (!Number.isNaN(scale) && scale !== "NaN" && scale > 0) {
          // helps detect if we have a key mismatch between our data sources
        }
      }
    })
    const sortedSkills = sortByPropText(values, "value").reverse()
    const topThreeSkills = sortedSkills.slice(0, 3)
    // converts top three skills into recommendations
    const recommendations = topThreeSkills.map(({ name }) => {
      if (!isGroup) {
        return autoTutorSentencesStudent[subjectName][name]
      } else return autoTutorSentences[subjectName][name]
    })
    if (!isStudent) {
      return recommendations
    } else {
      return grabAllSkills ? sortedSkills : topThreeSkills[0]
    }

    // omit any skills that don't show up in either byNode, skillWeights, tsData, or autoTutorSentences
  }
  // convert top three skills to auto-tutor text

  return getTopThreeSkills(byNode, bySubtest, subject, nodes, isStudent)

  // return top three text
}
